import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.44 14.969c.89.1 1.74-.045 2.453-.434.308-.168.593-.387.867-.663.381-.384.584-.612.795-.902l.026-.03c.264-.306.367-.501.388-.8.034-.467-.173-.825-.66-1.276a4.253 4.253 0 0 0-1.044-.696l-.247-.12a3.566 3.566 0 0 0-.77-.283c-.467-.104-.882-.044-1.23.203a2.244 2.244 0 0 0-.408.39l-.039.044c-.043.05-.07.079-.095.105-.192.2-.373.344-.557.442-.909.484-2.181.286-2.968-.464a2.638 2.638 0 0 1-.697-1.817c.013-.534.19-1.054.496-1.46a4.2 4.2 0 0 1 .39-.43l.114-.118c.294-.305.44-.647.437-1.049-.003-.34-.075-.596-.293-1.1l-.022-.05-.021-.048c-.19-.44-.346-.73-.544-.998-.306-.414-.615-.69-.972-.838a1.127 1.127 0 0 0-.776-.044c-.2.063-.326.145-.562.35l-.066.057c-.845.647-1.346 1.207-1.649 1.89-.497 1.122-.427 2.455.154 3.892.496 1.228 1.322 2.412 2.38 3.428a10.91 10.91 0 0 0 1.964 1.607c1.055.68 2.122 1.094 3.156 1.212Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.628 4.267-2.072-2.073v4.67a.33.33 0 1 1-.66 0v-4.67L9.825 4.267a.33.33 0 1 1-.466-.466l2.635-2.635a.33.33 0 0 1 .466 0L15.094 3.8a.33.33 0 0 1-.466.466Z",
    fill: "#00B388"
  }));
};

var SvgAnsweredOutbound = styled(SvgComponent).withConfig({
  displayName: "AnsweredOutbound__SvgAnsweredOutbound",
  componentId: "sc-1g3ysii-0"
})(["", " ", ""], size, color);
export default SvgAnsweredOutbound;